import { render, staticRenderFns } from "./moduleCompletion.vue?vue&type=template&id=0789f1d0&scoped=true&"
import script from "./moduleCompletion.vue?vue&type=script&lang=js&"
export * from "./moduleCompletion.vue?vue&type=script&lang=js&"
import style0 from "./moduleCompletion.vue?vue&type=style&index=0&id=0789f1d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0789f1d0",
  null
  
)

export default component.exports